import React, { useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import Dashboard from './components/Dashboard/Dashboard';
import AuthTemplate from './components/auth/AuthTemplate';
import SignUp from './components/auth/SignUp';
import Tracker from './components/Tracker/Tracker';
import EyeSightTracker from './components/Tracker/EyeSightTracker';
import Creport from './components/ChildReport/Creport';
import AdminLogin from './components/AdminLogin/AdminLogin';
import AdminDashboard from './components/AdminDashboard/AdminDashboard';
import Blogs from './components/Blogs/Blogs';
import BlogsList from './components/Blogs/Bloglist';
import EyeSightTest from './components/EyesightTracker/EyesightTest';
import Subscription from './components/Subscription/Subscription';


function App() {
	const [bearerToken, setBearerToken, blogToken, bloglistToken, eyesighttest, subscription] = useState(null);
	return (
		<Router>
			<Switch>
				<Route exact path='/' render={() => <Dashboard bearerToken={bearerToken} />} />
				<Route
					exact
					path='/growthtracker'
					render={() => <Tracker bearerToken={bearerToken} />}
				/>
				<Route
					exact
					path='/eyesighttracker'
					render={() => <EyeSightTracker bearerToken={bearerToken} />}
				/>
				<Route exact path='/creport' render={() => <Creport bearerToken={bearerToken} />} />
				<Route exact path='/login' render={() => <AuthTemplate />} />
				<Route exact path='/signup' render={() => <SignUp />} />
				<Route exact path='/blogs' render={() => <Blogs blogToken={blogToken} />} />
				<Route exact path='/blogs/bloglist' render={() => <BlogsList bloglistToken={bloglistToken} />} />
				<Route exact path='/eyesighttest' render={() => <EyeSightTest eyesighttest={eyesighttest} />} />
				<Route exact path='/subscription' render={() => <Subscription subscription={subscription} />} />
				<Route
					exact
					path='/admin/login'
					render={() => <AdminLogin setBearerToken={setBearerToken} />}
				/>
				<Route
					exact
					path='/admin/dashboard'
					render={() => <AdminDashboard bearerToken={bearerToken} />}
				/>
			</Switch>
		</Router>
	);
}

export default App;
